var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightlightblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.05,
    height: 19.741,
    viewBox: "0 0 12.05 19.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(235.429 39.12) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    x1: 7.808,
    y2: 7.808,
    transform: "translate(225.5 21.5)",
    fill: "none",
    stroke: "#93A6E8",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    x1: 7.808,
    y1: 7.25,
    transform: "translate(225.5 29.75)",
    fill: "none",
    stroke: "#93A6E8",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightlightblue);
export default __webpack_public_path__ + "static/media/arrow-right light blue.aaa935631b37210ff1f4e8705ac6d8ad.svg";
export { ForwardRef as ReactComponent };